import { render, staticRenderFns } from "./owner-workOrders.vue?vue&type=template&id=68b1832b&scoped=true&"
import script from "./owner-workOrders.vue?vue&type=script&lang=js&"
export * from "./owner-workOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b1832b",
  null
  
)

export default component.exports